module.exports = __webpack_public_path__ + "img/bg_main03_mask.1485441d.svg";